import React from 'react';
import { useTranslation } from 'react-i18next';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@app/shared/utils/common';
import { cookieImage } from '@app/assets';
import { DAY_TO_REWARD_MAP } from '@app/shared/constants/common';
import { StreakDay } from '@app/shared/types/common';

const dayCardVariants = cva('flex flex-col gap-2 overflow-hidden rounded-[10px] pb-1 text-center', {
  variants: {
    variant: {
      default: 'bg-blue-light',
      accepted: 'bg-[#3ab9fa]',
      current: 'animate-pulse-beat cursor-pointer bg-accent',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export interface DailyRewardDayCardProps extends VariantProps<typeof dayCardVariants> {
  day: StreakDay;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>, reward: number) => void;
}

export function DailyRewardDayCard({
  day,
  variant = 'default',
  className,
  onClick,
}: DailyRewardDayCardProps) {
  const { t } = useTranslation();

  return (
    <li
      className={cn(dayCardVariants({ variant }), className)}
      onClick={(e) => onClick && onClick(e, DAY_TO_REWARD_MAP[day])}
    >
      <span className="whitespace-nowrap bg-[#db9a6a] px-2 py-1 text-sm text-foreground">
        {t('common.day')} {day}
      </span>

      <img src={cookieImage} alt="cake" className="w-full px-2" />

      <span
        className={cn(
          'flex text-secondary-foreground items-center justify-center gap-1 px-2 text-[18px] font-semibold',
          variant !== 'default' && 'text-foreground'
        )}
      >
        {DAY_TO_REWARD_MAP[day]}
        <img src={cookieImage} alt="cookie" className="w-4" />
      </span>
    </li>
  );
}
